import { render, staticRenderFns } from "./lyrics.vue?vue&type=template&id=0ea5a94a&scoped=true"
import script from "./lyrics.vue?vue&type=script&lang=js"
export * from "./lyrics.vue?vue&type=script&lang=js"
import style0 from "./lyrics.vue?vue&type=style&index=0&id=0ea5a94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea5a94a",
  null
  
)

export default component.exports